import {LoaderFunctionArgs, redirect, ShouldRevalidateFunction} from 'react-router';
import {APP_PATH, ROOT_PATH} from '@/constants/routes';
import {PREVIOUS_PATH_KEY} from '@/constants/storage';
import {loadConfiguration} from '@/contexts/config/config.loader';
import {getProfile, UserProfile} from '@/repositories/beneva-api/endpoints/users';
import AuthenticationServiceInstance from '@/services/authentication';
import {hasCompleteUserProfile} from '@/utils/user-profile';

const PROFILE_PATH = '/app/profile';
const UNAVAILABLE_PATH = '/unavailable';

const shouldRedirectToProfile = (pathName: string) => pathName !== PROFILE_PATH;

export const AppLoader = async ({request}: LoaderFunctionArgs) => {
  const url = new URL(request.url);
  const pathName = `${url.pathname}${url.search}`;

  const user = await AuthenticationServiceInstance.getCurrentUser();

  if (!user) {
    return redirect(ROOT_PATH);
  }

  const config = await loadConfiguration();

  sessionStorage.setItem(PREVIOUS_PATH_KEY, pathName);

  try {
    const profile = await getProfile();
    const userProfile: UserProfile = profile.data;

    if (!hasCompleteUserProfile(userProfile) && shouldRedirectToProfile(pathName)) {
      return redirect(PROFILE_PATH);
    }

    return {config, user, userProfile};
  } catch (_error) {
    return redirect(UNAVAILABLE_PATH);
  }
};

// Revalidate when subroute goes back to /app for loader to do the redirect to profile if needed
export const revalidateOnAppPath: ShouldRevalidateFunction = ({nextUrl}) => {
  return nextUrl.pathname === APP_PATH;
};

export type LoaderData = Exclude<Awaited<ReturnType<typeof AppLoader>>, Response>;
